/**
 * Checks if in development environment.
 *
 * @returns {boolean} True if development environment; otherwise false.
 */
export const isDevEnv = () => {
  return process.env.NODE_ENV === 'development' || process.env.REACT_APP_BUILD_ENV === 'development';
};
